const React = require("react");
const formatTime = require("mn-utils/formatTime");
const adminCtor = require("./adminCtor");
const merchantCtor = require("./merchantCtor");

const displayDateTitle = ({date}) => formatTime.getRFC3339(date);
const displayDateTimeData = ({date}) => !!date
  ? (
    <>
      <div className="lh13 fw7">{formatTime(date, '{dd} {mmm}, {yyyy}', true)}</div>
      <div className="c717275 lh13 fw4 mt3">
        {formatTime(date, '{hh}:{MM}:{ss} {TT}', true)}
      </div>
    </>
  )
  : '';

const formatDetailedDate = ({date}) => !!date ? formatTime(date, '{dddd} {mmmm} {dd}, {yyyy} {hh}:{MM} {TT}') : '';

const basicProps = {titleHandler: displayDateTitle, hasCustomData: true}

const dateTimeProps = {...basicProps, dataHandler: displayDateTimeData};

const dateProps = {
  titleHandler: ({date}) => !!date ? formatTime(date, '{yyyy}-{mm}-{dd}', true) : '',
  dataHandler: ({date}) => !!date ? formatTime(date, '{dd} {mmm}, {yyyy}', true) : '',
  hasCustomData: true
};
const dateDetailedProps = {...basicProps, dataHandler: formatDetailedDate};

const displayDateAdmin = adminCtor(dateProps);
const displayDateTimeAdmin = adminCtor(dateTimeProps);

const displayDateMerchant = merchantCtor(dateProps);
const displayDateTimeMerchant = merchantCtor(dateTimeProps);

const displayDateDetailedAdmin = adminCtor(dateDetailedProps);
const displayDateDetailedMerchant = merchantCtor(dateDetailedProps);

module.exports = {
  displayDateAdmin,
  displayDateTimeAdmin,
  displayDateDetailedAdmin,

  displayDateMerchant,
  displayDateTimeMerchant,
  displayDateDetailedMerchant
};
